module.exports = __webpack_public_path__ + "img/googleplay.e3c15a71.svg";